export default function AdminStatsPage() {
  return <div>Stats will render here after migration.</div>
}
